import { gql } from 'apollo-angular';

export default gql`
  query fieldTypes {
    fieldTypes {
      __typename
      uri
      nameResourceId
      hintResourceId
      # manager
      fieldTypeProperties {
        uri
        nameResourceId
        hintResourceId
        sortOrder
        default
        isMandatory
        fieldTypePropertyTypeUri
      }
    }
  }
`;
